import script from "./appstore.vue?vue&type=script&setup=true&lang=js"
export * from "./appstore.vue?vue&type=script&setup=true&lang=js"

import "./appstore.vue?vue&type=style&index=0&id=5a7755c9&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a7755c9"]])

export default __exports__